<script lang="ts">
	import ApprovalCheckbox from "./Form/ApprovalCheckbox.svelte";

	let formControlClass = "";
	export { formControlClass as class };
	export let approvedAt: string | null = null;
</script>

<ApprovalCheckbox name="gdprApprovedAt" {approvedAt} class={formControlClass}>
	Souhlasím se&nbsp;<a
		class="text-black-400 hover:text-black-700 decoration-primary-400 underline transition-[color,text-decoration] duration-500 ease-in-out hover:decoration-transparent"
		href="/documents/SladkáDílnaZásadyZpracováníOsobníchÚdajů.pdf"
		target="_blank"
	>
		Zásadami zpracování osobních údajů
	</a>
</ApprovalCheckbox>
